export default __webpack_public_path__ + "static/media/laundry2-beforeB-1024w.6a77787b.png";